import UpperUser from './upperUser.vue';

export default UpperUser;